import React, { Component } from 'react';




// React Final Form
import { Field } from 'react-final-form';


const fieldStyle = {
  minHeight: "72px",
  width: "50%",
};

class FieldCreator extends Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  render() {
    return (
      <div>
        <Field
          {...this.props.values}
          style={fieldStyle}
        >
          {this.props.fill_values}
        </Field>
      </div>
    )
  }

}
export default FieldCreator;


// WEBPACK FOOTER //
// src/components/innerComponents/FieldCreator.js